import { useTheme } from '@mui/material';

export const useSearchFormContainerQuery = () => {
    const theme = useTheme();
    const padding = parseInt(theme.spacing(16));
    const sm = theme.breakpoints.values.sm;
    const smallWidth = sm + padding;
    return `@container (max-width: ${smallWidth}px)`;
};
